module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/3_67e0947465a88b7c1474e7ad61eb6f24.png";